"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));
var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));
var _Error = _interopRequireDefault(require("@material-ui/icons/Error"));
var _withWidth = _interopRequireDefault(require("@material-ui/core/withWidth"));
var _i18n = require("../../../../Framework/i18n");
var _MainButton = _interopRequireDefault(require("../../../../Shared/Components/MainButton"));
var _CustomDialog = _interopRequireDefault(require("../../../../Shared/Components/CustomDialog"));
var _AnalyticsWrapper = _interopRequireDefault(require("../Analytics/AnalyticsWrapper"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var styles = function styles(theme) {
  return {
    dialogTitleRoot: {
      fontSize: '1.5rem',
      fontWeight: 400
    },
    TypographyCaption: {
      fontSize: 12,
      lineHeight: 1.7
    },
    errorResult: {
      background: '#ED1C29',
      color: '#fff',
      padding: '20px',
      borderRadius: '4px',
      fontSize: 16,
      lineHeight: 1.7,
      textAlign: 'center'
    },
    errorResultIcon: {
      "float": 'left'
    },
    codeFieldWrapper: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: 24,
      marginBottom: 32
    },
    codeField: _defineProperty({
      borderRadius: 4,
      width: 200,
      height: 20
    }, theme.breakpoints.down('xs'), {
      width: 370
    }),
    codeFieldInput: _defineProperty({
      fontSize: '24px',
      lineHeight: '28px',
      marginTop: 8,
      marginBottom: 8,
      textAlign: 'center',
      height: 20,
      padding: '10px',
      fontWeight: 'bold'
    }, theme.breakpoints.down('xs'), {
      minWidth: 50
    }),
    codeFieldLabel: {
      fontSize: '18px',
      fontWeight: 'bold',
      textAlign: 'center',
      marginLeft: 1,
      width: '99%',
      backgroundColor: '#fff',
      transform: 'translate(0px, 20px) scale(1)'
    },
    activeButton: {
      padding: '6px 15px',
      marginTop: 10
    }
  };
};
var LoadConfiguration = /*#__PURE__*/function (_React$Component) {
  _inherits(LoadConfiguration, _React$Component);
  var _super = _createSuper(LoadConfiguration);
  function LoadConfiguration() {
    var _this;
    _classCallCheck(this, LoadConfiguration);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "onChange", function (e) {
      _this.props.onCodeChange(e.target.value);
    });
    return _this;
  }
  _createClass(LoadConfiguration, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        workInProgress = _this$props.workInProgress,
        onLoadClick = _this$props.onLoadClick,
        errorMessage = _this$props.errorMessage,
        show = _this$props.show,
        onClose = _this$props.onClose,
        loadCode = _this$props.loadCode;
      return /*#__PURE__*/_react["default"].createElement(_CustomDialog["default"], {
        open: show,
        onClose: onClose,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        dialogTitle: (0, _i18n.t)('loadConfiguration.dialogTitle'),
        onCancel: onClose
      }, /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], null, workInProgress && /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        variant: "body1",
        classes: {
          root: classes.TypographyCaption
        },
        id: "alert-dialog-description"
      }, (0, _i18n.t)('loadConfiguration.loadingInProgress')), !workInProgress && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        variant: "body1",
        classes: {
          root: classes.TypographyCaption
        },
        id: "alert-dialog-description"
      }, (0, _i18n.t)('loadConfiguration.enterCode')), /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.codeFieldWrapper
      }, /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
        className: classes.codeField,
        value: loadCode,
        variant: 'outlined',
        onChange: this.onChange,
        label: (0, _i18n.t)('loadConfiguration.codeInputPlaceholder'),
        InputProps: {
          classes: {
            input: classes.codeFieldInput
          },
          disableUnderline: true
        },
        InputLabelProps: {
          classes: {
            outlined: classes.codeFieldLabel
          },
          disableUnderline: true
        }
      }))), errorMessage && /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.errorResult
      }, /*#__PURE__*/_react["default"].createElement(_Error["default"], {
        className: classes.errorResultIcon
      }), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        variant: "body1"
      }, (0, _i18n.t)(errorMessage)))), /*#__PURE__*/_react["default"].createElement(_DialogActions["default"], null, /*#__PURE__*/_react["default"].createElement(_AnalyticsWrapper["default"], {
        targetId: "load_request",
        data: loadCode
      }, /*#__PURE__*/_react["default"].createElement(_MainButton["default"], {
        onClick: onLoadClick,
        variant: "contained",
        size: "medium",
        className: classes.activeButton
      }, (0, _i18n.t)('loadConfiguration.loadButton')))));
    }
  }]);
  return LoadConfiguration;
}(_react["default"].Component);
var _default = exports["default"] = (0, _withWidth["default"])()((0, _styles.withStyles)(styles, {
  name: 'LoadConfiguration'
})(LoadConfiguration));